import { travel, axiosConfig } from 'api';

export interface Reason {
  id: string;
  name: string;
}

export interface ReasonsResponse {
  data: Reason[];
}

export const getReasonsForTravel = (): Promise<ReasonsResponse> =>
  travel.get('/travels/GetReasonsForTravel', axiosConfig).then((response) => response.data);
